import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g2,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_gen_2_auto_recovery_under_voltage from '@devices/settings/device_settings/safety_gen_2_auto_recovery_under_voltage.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import multi_settings_gen_2 from '@devices/settings/device_settings/multi_settings_gen_2.js';
import roller_plus_pm_settings_gen_2 from '@devices/settings/common_settings/roller_plus_pm_settings_gen_2';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'ShellyPlus2PM',
	friendly_name: 'Plus 2 PM',
	family: 'relay',
	isPM: true,
	addons: addon_plus_devices_g2,
	reset_from_input: true,
	modes: {
		relay: {
			sceneCapabilities: createSceneCapabilities({
				template: 'dual_relay',
			}),
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			dashInfoLabels: 'relay-pm',
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				safety_gen_2_auto_recovery_under_voltage,
				app_setting_pm_gen_2,
				share,
				multi_settings_gen_2,
			],
		},
		roller: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			slider: true,
			settings: roller_plus_pm_settings_gen_2,
		},
	},
};
